import { render, staticRenderFns } from "./container.page.vue?vue&type=template&id=24d01823"
import script from "./container.page.vue?vue&type=script&lang=ts"
export * from "./container.page.vue?vue&type=script&lang=ts"
import style0 from "./container.page.vue?vue&type=style&index=0&id=24d01823&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports